<div>
  <!-- title container -->
  <div class="ly-sp-s-bottom" *ngIf="this.getValue() && getValue().length !== 0">
    <span class="bs-h2 th-text-main" *ngIf="this.getTitle() !== ''">{{this.getTitle()}}</span>
  </div>

  <!-- message container -->
  <ng-container #messagesListContainer></ng-container>
</div>
